import React from 'react';
import './AboutSection.scss';
import FileSaver from 'file-saver';

const AboutSection = () => {

    const saveFile = () => {
        FileSaver.saveAs(
            process.env.PUBLIC_URL + "/assets/cv.pdf",
            "cv.pdf");
        
        };

    return (
        <div className="AboutSection">
            
            <div className="about-info">
                <h4>I am<span> Sandeep Bisht</span></h4>
                <p className="about-text">
                I’m a hard working and dedicated front-end developer with a keen eye for detail, and a determination to deliver the very highest quality. I take great pride in my work, and I always try to better myself with every project I work on.
                </p>
                <div className="about-details">
                    <div className="left-section">
                        <p>Full Name</p>
                        <p>Age</p>
                        <p>Nationality</p>
                        <p>Languages</p>
                        <p>Address</p>
                       
                    </div>
                    <div className="right-section">
                        <p>: Sandeep Bisht</p>
                        <p>: 27</p>
                        <p>: Indian</p>
                        <p>: Hindi,English</p>
                        <p>: Z-Block Sector-12 Noida,Uttar Pradesh,India</p>
                       
                    </div>
                </div>
                <button className="btn" onClick={saveFile}>Download Cv</button>
            </div>
        </div>
    )
}

export default AboutSection
